import { Box, Grid } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ProviderSettingsWrapper } from "../styles";
import CustomTextInput from "components/Forms/CustomTextInput";
import useProviderEmail from "pages/Providers/hooks/useProviderEmail";

const ProviderEmail = ({ generalAccountEmail }) => {
	const { t } = useTranslation();
	const { 
		providerEmailForm,
	  handleProviderEmailForm,
		loading,
    handleChange,
    isDirty,
	} = useProviderEmail(generalAccountEmail);

  return (
     <ProviderSettingsWrapper>
      <Box
        sx={{
          px: 2,
          pt: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <FormProvider {...providerEmailForm}>
					<form onSubmit={providerEmailForm.handleSubmit(handleProviderEmailForm)}>
						<Grid container spacing={2}>
							<Grid item md={6}>
								<Box sx={{ height: '74px' }}>
									<CustomTextInput
										sx={{ width: '100%', maxWidth: '342px' }}
										name="generalAccountEmail"
										label="General Account Email"
										type="email"
                    onChange={handleChange}
								 />
								</Box>
							</Grid>
						</Grid>
						<Box 
						  sx={{
								 display: 'flex', 
								 justifyContent: 'flex-end', 
							}}
						>
							<LoadingButton
								variant="contained"
								color="primary"
								type="submit"
								loading={loading}
								disabled={
									!providerEmailForm.formState.isValid ||
									!isDirty ||
									loading 
								}
							>
								{t('Save')}
							</LoadingButton>
            </Box>
					</form>
				</FormProvider>
      </Box>
    </ProviderSettingsWrapper>
  )
};

export default ProviderEmail;
